import React from "react";
import SubscriptionCartItem from "./item";
import { useSelector, useDispatch } from "react-redux";
import { useGlobalContext } from "context/global";
import clsx from "clsx/lite";
import CartUpsell from "components/cart/upsell";
import { onSideProductRemoved, getCartItemsSeparated } from "utils/cart";
import ClearCart from "components/cart/clear";
import { CLEAR_SUBSCRIPTION_CART } from "utils/action-types";

const SubscriptionCartBody = ({ isSticky }) => {
	const { lines, removeCount } = useSelector(state => state.account.subscription);
	const { translation, cartSettings: { subscriptionUpsell } } = useGlobalContext();
	const dispatch = useDispatch();

	const { coreProducts, sideProducts } = getCartItemsSeparated(Object.values(lines).sort((a, b) => a.index - b.index));

	return (
		<>
			<div className={clsx("cart-body flex flex-col gap-y-5 p-4", isSticky && "max-h-[40vh]")}>
				{coreProducts.map(item => <SubscriptionCartItem key={item?.variantShopifyId} item={item} />)}
				{sideProducts.length > 0 && (
					<div className="border-t border-gray-200 py-4">
						<p className="text-sm font-semibold mb-2">{translation.cart?.side_products}</p>
						<div className="flex flex-col gap-y-5">
							{sideProducts.map(item => <SubscriptionCartItem key={item.id} item={item}
								onRemoved={() => onSideProductRemoved(item.variantShopifyId)} />)}
						</div>
					</div>)}
				<ClearCart removeCount={removeCount} onClick={() => dispatch({ type: CLEAR_SUBSCRIPTION_CART })} />
			</div>
			<CartUpsell config={subscriptionUpsell} items={lines} isSubscription />
		</>
	);
};

export default SubscriptionCartBody;